import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Heart, Play } from "lucide-react";
import { api } from "../lib/api";
import { fileUrl, mediaSrc } from "../components/site/HeroSlides";
import { StoryBubbles } from "../components/social/StoryBubbles";
import { TimelineRail, monthLabel } from "../components/social/TimelineRail";

function Card({ p }) {
  const ref = useRef(null);
  return (
    <section id={`post-${p.item_id}`} className="relative h-[100dvh] snap-start flex items-center justify-center bg-black" data-testid={`hub-post-${p.item_id}`}>
      {p.type === "video" ? <video ref={ref} src={fileUrl(p.path)} loop playsInline muted autoPlay className="h-full w-full object-contain" />
        : <img src={fileUrl(p.path)} alt={p.caption} loading="lazy" className="h-full w-full object-contain" />}
      {p.type === "video" && <Play className="absolute top-24 right-4 w-5 h-5 text-white/60" />}
      <div className="absolute inset-x-0 bottom-0 p-5 pb-8 bg-gradient-to-t from-black/85 to-transparent">
        <Link to={`/site/${p.slug}/social?p=${p.item_id}`} className="flex items-center gap-2 mb-2" data-testid={`hub-post-couple-${p.item_id}`}>
          <span className="w-8 h-8 rounded-full overflow-hidden bg-[#222] ring-1 ring-[var(--gold)]">{p.cover_image && <img src={mediaSrc(p.cover_image)} alt="" className="w-full h-full object-cover" />}</span>
          <span className="font-serif text-lg">{p.couple_names}</span>
        </Link>
        {p.caption && <p className="text-sm text-white/85 line-clamp-2">{p.caption}</p>}
        <p className="text-[11px] text-white/50 mt-1 flex items-center gap-3"><span>{monthLabel(p)}</span><span className="flex items-center gap-1"><Heart className="w-3 h-3" /> {p.hearts}</span></p>
      </div>
    </section>
  );
}

export default function SocialHubPage() {
  const [posts, setPosts] = useState([]);
  const [next, setNext] = useState("");
  const [done, setDone] = useState(false);
  const root = useRef(null);
  const more = useCallback(async (before = "") => {
    const { data } = await api.get(`/public/social-feed?limit=12${before ? `&before=${encodeURIComponent(before)}` : ""}`);
    setPosts((x) => (before ? [...x, ...data.posts] : data.posts));
    setNext(data.next || ""); setDone(!data.next);
  }, []);
  useEffect(() => { more().catch(() => setDone(true)); }, [more]);
  function onScroll(e) {
    const el = e.currentTarget;
    if (!done && next && el.scrollTop + el.clientHeight * 3 > el.scrollHeight) { const n = next; setNext(""); more(n).catch(() => {}); }
  }
  return (
    <div className="h-[100dvh] bg-black text-white relative" data-testid="social-hub">
      <header className="absolute top-0 inset-x-0 z-30 bg-gradient-to-b from-black/90 via-black/60 to-transparent pt-3">
        <div className="flex items-center gap-3 px-4"><Link to="/" aria-label="Home" data-testid="social-hub-back"><ArrowLeft className="w-5 h-5" /></Link><h1 className="font-serif text-2xl">Social</h1></div>
        <StoryBubbles />
      </header>
      <div ref={root} onScroll={onScroll} className="h-full overflow-y-scroll snap-y snap-mandatory md:max-w-md md:mx-auto" data-testid="social-hub-feed">
        {done && !posts.length && <div className="h-full flex items-center justify-center font-serif text-3xl text-white/60 px-8 text-center" data-testid="social-hub-empty">No public moments yet.</div>}
        {posts.map((p) => <Card key={p.item_id} p={p} />)}
      </div>
      <TimelineRail posts={posts} rootRef={root} labelOf={monthLabel} />
    </div>
  );
}
